import { render, staticRenderFns } from "./TableDetail_deprecated.vue?vue&type=template&id=968dcfcc&scoped=true&"
import script from "./TableDetail_deprecated.vue?vue&type=script&lang=js&"
export * from "./TableDetail_deprecated.vue?vue&type=script&lang=js&"
import style0 from "./TableDetail_deprecated.vue?vue&type=style&index=0&id=968dcfcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968dcfcc",
  null
  
)

export default component.exports